export default {
  value: null,
  meta: {
    title: null,
    captions: [],
    duration: null
  },
}
